import {EmploymentStatus} from "../../../app/interfaces";
import {
    EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED,
    EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED,
    EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE, EMPLOYMENT_STATUS_TERMINATION_REQUEST
} from "../../../utils/constants";
import {defaultTheme} from "../../../styles/themes/default";
import styled from "styled-components";

const colorForStatus = (status: EmploymentStatus): {
    background: string,
    title: string,
    message: string,
    border: string
} => {
    switch (status) {
        case EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED:
        case EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE:
            return {
                background: defaultTheme.white,
                title: defaultTheme.accent,
                message: defaultTheme.grayDark,
                border: `1px solid ${defaultTheme.grayDivider}`
            }
        case EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED:
            return {
                background: defaultTheme.green,
                title: defaultTheme.white,
                message: defaultTheme.white,
                border: 'unset'
            }
        case EMPLOYMENT_STATUS_TERMINATION_REQUEST:
            return {
                background: defaultTheme.red,
                title: defaultTheme.white,
                message: defaultTheme.white,
                border: 'unset'
            }
        default:
            return {
                background: defaultTheme.white,
                title: defaultTheme.accent,
                message: defaultTheme.grayDark,
                border: `1px solid ${defaultTheme.grayDivider}`
            }
    }
}

interface interfaceImportantMessagesContainerProps {
    status: EmploymentStatus
}

export const ImportantMessagesContainer = styled.div<interfaceImportantMessagesContainerProps>`
  padding: 32px;
  background: ${props => colorForStatus(props.status).background};
  border-radius: 8px;
  border: ${props => colorForStatus(props.status).border};
  
  .message-wrapper{
    display: flex;
    .icon-box{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px !important;
      margin-right: 20px;
    }
    .message{
      > h1 {
        font-size: 19px;
        font-weight: 700;
        line-height: 23px;
        letter-spacing: 0.4px;
        text-align: left;
        color: ${props => colorForStatus(props.status).title};
        margin-bottom: 10px;
      }

      > p {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.3px;
        text-align: left;
        color: ${props => colorForStatus(props.status).message};
      }
      > button {
        margin-top: 15px;
        border-radius: 31px;
        background: transparent;
        border: 1px solid ${props => colorForStatus(props.status).title};
        color: ${props => colorForStatus(props.status).title};
        padding: 12px 24px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0.2px;
      }
    }
  }
    .message-action {
        align-self: flex-end;
        margin-left: auto;
    }
`;


